import { useForm } from 'react-hook-form';
import { PasswordChangeData } from '../types';
import { Field, Input, Label } from '@headlessui/react';
import { useAccount } from '../hooks';
import { Button } from '../../ui/components/Button';
import { api } from '../api';

type Props = {
  onSuccess: () => void,
  onFailure: (error: object) => void
}

export const PasswordChangeForm = ({ onFailure, onSuccess }: Props) => {

  const { register, handleSubmit, formState: { isSubmitting }, watch } = useForm<PasswordChangeData>();
  const [changePassword] = api.useChangePasswordMutation();

  const account = useAccount();

  const doSubmit = (data: PasswordChangeData) => {
    changePassword(data).unwrap().then(onSuccess).catch(onFailure);
  };

  const passwordsMatch = watch('new_password1') == watch('new_password2');

  return (
    <div className='grow my-4 p-4'>
      <h3 className='text-lg my-4'>Change password</h3>
      <form
        className='pl-4 grid grid-cols-[auto_1fr] gap-4 items-center'
        onSubmit={handleSubmit(doSubmit)}
      >
        <input
          autoComplete='off'
          hidden
          name='username'
          readOnly
          type='text'
          value={account?.email}
        />
        <Field className='grid grid-cols-subgrid col-span-2 items-center'>
          <Label className='inline'>New password</Label>
          <Input
            {...register('new_password1', { required: true })}
            autoComplete='new-password'
            className='border border-jw-blue'
            type='password'
          />
        </Field>
        <Field className='grid grid-cols-subgrid col-span-2 items-center'>
          <Label className='inline'>New password (again)</Label>
          <Input
            {...register('new_password2', { required: true })}
            autoComplete='new-password'
            className='border border-jw-blue'
            type='password'
          />
        </Field>
        {
          !passwordsMatch && (
            <div className='text-sm text-red-500 col-span-2'>
              Passwords do not match
            </div>
          )
        }
        <Button
          className='col-span-2 justify-self-start'
          disabled={isSubmitting || !passwordsMatch}
          type='submit'
        >
          Change password
        </Button>
      </form>
    </div>
  );
};
